import React, { Component } from 'react'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import Slider from "react-slick";

// import arrowDesktop from '../../assets/icons/slider-arrow-desktop.svg'
// import arrowMobile from '../../assets/icons/slider-arrow-mobile.svg'

import { media } from '../../styles/utils';
import { hoverState, padding, bgImage, bgIcon } from '../../styles/global';

// Slider documentation ↓↓
// https://github.com/ItsMrAkhil/react-styled-carousel

class Carousel extends Component {

	constructor(props) {
		super(props);
		this.slider = React.createRef();
	}

    static defaultProps = {
        height: 500,
        settings: {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }

    state = {
        totalSlides: this.props.slides ? this.props.slides.length : 0,
        activeSlide: 1,
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { onSlideChange } = this.props;

        if (prevProps.activeSlide !== this.props.activeSlide) {
            this.setState({
                activeSlide: this.props.activeSlide
            })

            this.slider.slickGoTo(this.props.activeSlide, true)
            // this.props.aferChange && this.props.aferChange(this.props.activeSlide)
        }
    }  

    onBeforeChange = (oldIndex, newIndex) => {
        this.setState({
            activeSlide: (newIndex + 1)
        })

        this.props.beforeChange && this.props.beforeChange((newIndex + 1))
    }

    onAfterChange = (newIndex) => {
        this.setState({
            activeSlide: (newIndex + 1)
        })

        this.props.afterChange && this.props.afterChange((newIndex + 1))
    }

    renderSlideCounter = () => {
        const { totalSlides, activeSlide } = this.state;

        return (
            <SlideCounter>
                {`${activeSlide} of ${totalSlides}`}
            </SlideCounter>
        )
    }

    renderControls = () => {
        return (
            <Controls>
                <SliderArrow
                    onClick={() => this.slider.current.slickPrev()}
                />
                {this.renderSlideCounter()}
                <SliderArrow
                    onClick={() => this.slider.current.slickNext()}
                />
            </Controls>
        )
    }

    renderSlides = () => {
        const { slides, height } = this.props;

        if (slides) {
            return slides.map((slide, i) => {
                return (
                    <Slide 
                        key={i}
                        height={height}
                    >
                        {slide}
                    </Slide>
                )
            })
        }
    }
    
    render() {
        const { height, styles, settings, controls } = this.props;

        return (
            <Container
                styles={styles}
            >
                <Slider
                    {...settings}
                    ref={this.slider}
                    beforeChange={this.onBeforeChange}
                    afterChange={this.onAfterChange}
                >
                    {this.renderSlides()}
                </Slider>
                {controls && this.renderControls()}
            </Container>
        )
    }
}

const Container = styled.div`
    position: relative;
    width: 100%;

    ${props => {
        return props.styles
    }}
`

const Slide = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    height: ${props => props.height};

    &:focus {
        outline: none;
    }

    transform: translate3d(0, 0, 0);
    will-change: transfrom;



`

// Counter

const SlideCounter = styled.div`
    font-family: 'GT America Expanded Bold';
    font-size: 12px;
    text-transform: uppercase;
`

// Controls

const Controls = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 13px;
`

const SliderArrow = styled.div`
    background-image: url();
    ${bgIcon}
    width: 52px;
    height: 16px;
    ${hoverState}

    &:last-child {
        transform: rotate(180deg)
    }

    ${media.phone`
        background-image: url();
        width: 32px;
        height: 10px;
    `}
`

injectGlobal`
    .slick-list {
        overflow: visible !important;
    }

    .slick-slide {
        position: relative;
        z-index: 1;
        cursor: pointer;
    }
    
    .slick-active {
        position: relative;
        z-index: 10;
        cursor: zoom-in;
    }
`

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js